module.exports = __webpack_public_path__ + "media/images/presta_busc/odontologo-a5e8566a05aa4be1b57f376e84ed44d2.svg";